/**
 * This mixin used for Widgets
 */
// widgets
import HeadingWidget from '@/components/dynamic-list-items/widgets/HeadingWidget.vue'
import TextWidget from '@/components/dynamic-list-items/widgets/TextWidget.vue'
import SpacerWidget from '@/components/dynamic-list-items/widgets/SpacerWidget.vue'
import NavPillsWidget from '@/components/dynamic-list-items/widgets/NavPillsWidget.vue'
import NavPillsLargeWidget from '@/components/dynamic-list-items/widgets/NavPillsLargeWidget.vue'
import ImageWidget from '@/components/dynamic-list-items/widgets/ImageWidget.vue'
import VideoWidget from '@/components/dynamic-list-items/widgets/VideoWidget.vue'
import TextAndImageWidget from '@/components/dynamic-list-items/widgets/TextAndImageWidget.vue'
import CTABlockWidget from '@/components/dynamic-list-items/widgets/CTABlockWidget.vue'
import GalleryWidget from '@/components/dynamic-list-items/widgets/GalleryWidget.vue'
import MapWidget from '@/components/dynamic-list-items/widgets/MapWidget.vue'
import StandardEventsFeedWidget from '@/components/dynamic-list-items/widgets/feeds/StandardEventsFeedWidget.vue'
import HistoryFiguresWidget from '@/components/dynamic-list-items/widgets/HistoryFiguresWidget.vue'
import AdPlacementWidget from '@/components/dynamic-list-items/widgets/AdPlacementWidget.vue'
import CardsSetWidget from '@/components/dynamic-list-items/widgets/CardsSetWidget.vue'
import IntroEventsFeedWidget from '@/components/dynamic-list-items/widgets/feeds/IntroEventsFeedWidget.vue'
import SliderEventsFeedWidget from '@/components/dynamic-list-items/widgets/feeds/SliderEventsFeedWidget.vue'
import PagesFeedWidget from '@/components/dynamic-list-items/widgets/feeds/PagesFeedWidget.vue'
import BlogFeedWidget from '@/components/dynamic-list-items/widgets/feeds/BlogFeedWidget.vue'
import PlacesFeedWidget from '@/components/dynamic-list-items/widgets/feeds/PlacesFeedWidget.vue'
import PlacesChosenWidget from '@/components/dynamic-list-items/widgets/feeds/PlacesChosenWidget.vue'
import EventsPlacesRelationChosenWidgetInput from '@/components/dynamic-list-items/widgets/feeds/byEntity/EventsPlacesRelationChosenWidget.vue'
import CitiesFeedWidget from '@/components/dynamic-list-items/widgets/feeds/CitiesFeedWidget.vue'
import RoutesFeedWidget from '@/components/dynamic-list-items/widgets/feeds/RoutesFeedWidget.vue'
import AudioGuidesFeedWidget from '@/components/dynamic-list-items/widgets/feeds/AudioGuidesFeedWidget.vue'
import HotelsFeedWidget from '@/components/dynamic-list-items/widgets/feeds/HotelsFeedWidget.vue'

// options
import Option from '@/utils/options/Option'
const options = [
  new Option('Скрыть', 'hide'),
  new Option('Дублировать', 'duplicate'),
  new Option('Скопировать', 'copy'),
  new Option('Вставить', 'paste', '', true, true),
  new Option('Удалить', 'delete', 'borderTop', true)
]
// component export
export default {
  options,
  components: {
    HeadingWidget,
    TextWidget,
    SpacerWidget,
    NavPillsWidget,
    NavPillsLargeWidget,
    ImageWidget,
    VideoWidget,
    TextAndImageWidget,
    CTABlockWidget,
    GalleryWidget,
    MapWidget,
    StandardEventsFeedWidget,
    IntroEventsFeedWidget,
    SliderEventsFeedWidget,
    PagesFeedWidget,
    BlogFeedWidget,
    PlacesFeedWidget,
    PlacesChosenWidget,
    EventsPlacesRelationChosenWidgetInput,
    CitiesFeedWidget,
    RoutesFeedWidget,
    AudioGuidesFeedWidget,
    HistoryFiguresWidget,
    AdPlacementWidget,
    HotelsFeedWidget,
    CardsSetWidget
  }
}
